import React from 'react'
import styled from 'styled-components';
import { IoIosAdd } from "react-icons/io";

const Button = styled.button`
  padding: 10px;
  font-size: 30px;
  background-color: transparent;
  color: var(--color-grey-50);
  border: none;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.6s ease;

  &:hover {
    color: var(--color-grey-700);
    background-color: var(--color-grey-100);
  }
`;

function AddButton({children, onclick}) {
  return (
    <Button onclick={onclick} ><IoIosAdd /></Button> 
    )
}

export default AddButton